<template>
    <button
        v-tooltip="tooltip"
        v-bind="$attrs"
        :dusk="dusk"
        type="button"
        :class="[
            'flex',
            'items-center',
            'flex-row',
            'justify-start',
            'p-2',
            'hover:bg-theme-icon-bg',
            'focus-visible:ring-2',
            'focus-visible:ring-blue-500',
            'focus-visible:ring-offset-2',
            { rounded: rounded },
        ]"
        :aria-label="effectiveAriaLabel"
        :data-action="dataAction"
        :data-float-label="dataFloatLabel"
        :disabled="disabled"
        @click="emitClick"
    >
        <slot>
            <svg-icon
                :key="icon"
                :style="iconCustomStyle"
                :fill="iconCustomFill"
                :icon="icon"
                :width="width"
                :height="height"
            />
            <span v-if="btnText" class="ml-3 text-theme-text">{{ btnText }}</span>
        </slot>
    </button>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        width: {
            type: String,
            required: false,
            default: '26px',
        },
        height: {
            type: String,
            required: false,
            default: '26px',
        },
        dusk: {
            type: String,
            required: false,
            default: null,
        },
        btnText: {
            type: String,
            required: false,
            default: null,
        },
        icon: {
            type: String,
            required: false,
            default: null,
        },
        iconCustomStyle: {
            type: [String, Object],
            required: false,
            default: null,
        },
        iconCustomFill: {
            type: String,
            required: false,
            default: null,
        },
        dataAction: {
            type: String,
            required: false,
            default: null,
        },
        dataFloatLabel: {
            type: String,
            required: false,
            default: null,
        },
        tooltip: {
            type: String,
            required: false,
            default: null,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        rounded: {
            type: Boolean,
            required: false,
            default: true,
        },
        ariaLabel: {
            type: String,
            required: false,
            default: null,
        },
    },
    emits: ['click'],
    computed: {
        effectiveAriaLabel() {
            if (this.ariaLabel) return this.ariaLabel;
            if (!this.btnText && this.tooltip) return this.tooltip;
            return null;
        },
    },
    methods: {
        emitClick() {
            this.$emit('click');
        },
    },
};
</script>
